module.exports = __webpack_public_path__ + "static/img/06-Country-Hollow.05e19a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-match/06-Country-Hollow.jpg
// module id = CM0B
// module chunks = 12